import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import styled from '@mui/material/styles/styled';
import PropTypes from 'prop-types';

import loadingImg from '../../../assets/loading.svg';
import Svg from '../svg/Svg';

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: theme.palette.grey[50],
}));

const StyledLoadingWrapper = styled('div')(() => ({
  minHeight: '100px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const Loading = ({ fullscreen = false }) => {
  return (
    <>
      {fullscreen ? (
        <StyledBackdrop open={true} aria-label="loading">
          <CircularProgress color="inherit" />
        </StyledBackdrop>
      ) : (
        <StyledLoadingWrapper aria-label="data loading">
          <Svg width={60} src={loadingImg} />
        </StyledLoadingWrapper>
      )}
    </>
  );
};

Loading.propTypes = {
  fullscreen: PropTypes.bool,
};

export default Loading;
